var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"circle-container","width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{attrs:{"transform":'translate(' + _vm.svgWidth / 2 + ',' + _vm.svgHeight / 2 + ')'}},[_c('text',{staticClass:"circle-text"})])])}
var staticRenderFns = []

export { render, staticRenderFns }